import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@/components/dotLoader/DotLoader";
import { faBellSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { WaveNotificationSettingsState } from "./useWaveNotificationSettings";
interface WaveMutedNotificationButtonProps {
  readonly waveId: string;
  readonly settings: WaveNotificationSettingsState;
}
export default function WaveMutedNotificationButton(t0) {
  const $ = _c(12);
  const {
    waveId,
    settings
  } = t0;
  const t1 = `mute-tooltip-${waveId}`;
  let t2;
  if ($[0] !== settings.muteTooltip || $[1] !== t1) {
    t2 = <Tooltip id={t1}>{settings.muteTooltip}</Tooltip>;
    $[0] = settings.muteTooltip;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== settings.muteLoading) {
    t3 = settings.muteLoading ? <Spinner dimension={14} /> : <><FontAwesomeIcon icon={faBellSlash} className="tw-size-3.5 tw-flex-shrink-0" /><span>Muted</span></>;
    $[3] = settings.muteLoading;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== settings.muteLoading || $[6] !== settings.onMuteClick || $[7] !== t3) {
    t4 = <button disabled={settings.muteLoading} onClick={settings.onMuteClick} className="tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-3 tw-text-xs tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-iron-300 lg:tw-h-9" aria-label="Unmute wave">{t3}</button>;
    $[5] = settings.muteLoading;
    $[6] = settings.onMuteClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="tw-w-full"><OverlayTrigger placement="top" overlay={t2}>{t4}</OverlayTrigger></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}